module.exports = __webpack_public_path__ + "static/media/san raffaele.7b7bf36c.png";